import { Box, Flex, Image, ListItem, Text } from "@chakra-ui/react";
import { SpotType } from "~/generated/graphql.types";
import { SpotOrderBadge } from "~/routes/_shared/SpotOrderBadge";
import { SpotForSidebar } from "../convertType";
import { AddMarginLeft } from "../ComponentLayouter/AddMarginLeft";
import { WriteLeftDotLine } from "../ComponentLayouter/WriteLeftDotLine";
import { useContext } from "react";
import { EditModeContext, ViewMode } from "../../..";
import cafe from "../../../../../assets/icon_cafe.svg";
import restroom from "../../../../../assets/icon_toilet.svg";
import parkingFree from "../../../../../assets/icon_parking_free.svg";
import parlingPaid from "../../../../../assets/icon_parking_paid.svg";
import restaurant from "../../../../../assets/icon_restaurant.svg";
import music from "../../../../../assets/icon_music.svg";

export const SpotListItem = ({
  spot,
  isSelected,
  onClick,
}: {
  spot: SpotForSidebar;
  isSelected: boolean;
  onClick: () => void;
}) => {
  const { viewMode } = useContext(EditModeContext);
  const Mergin = spot.parentSpotId
    ? AddMarginLeft
    : spot.spotType === SpotType.RoutingGuide
    ? WriteLeftDotLine
    : Box;

  return (
    <Mergin>
      <ListItem
        data-testid={"spot-list-item"}
        my={2}
        p={spot.spotType === SpotType.RoutingGuide ? 1.5 : 3}
        flex={1}
        color="white"
        bgColor="#071223"
        justifyContent={"space-between"}
        borderColor="pink.600"
        borderWidth={isSelected ? 3 : 0}
        onClick={onClick}
      >
        <Flex w="full" direction="row">
          <Box>
            <SpotOrderBadge label={spot.spotOrderLabel} spot={spot} />
          </Box>
          <Box>
            {!spot.isRoutingGuide ? (
              <Flex>
                <NameView spot={spot} />
                {spot.hasMusic ? <Image src={music} h={8} /> : null}
              </Flex>
            ) : null}

            {viewMode === ViewMode.spotsView ? (
              <Flex w="full" ml={2} mt={2} gap={2}>
                {spot.hasCafe ? <Image src={cafe} h={8} /> : null}
                {spot.hasRestaurant ? <Image src={restaurant} h={8} /> : null}
                {spot.hasRestroom ? <Image src={restroom} h={8} /> : null}
                {spot.hasFreeParking ? <Image src={parlingPaid} h={8} /> : null}
                {spot.hasPaidParking ? <Image src={parkingFree} h={8} /> : null}
              </Flex>
            ) : null}
            {viewMode === ViewMode.spotsView ? (
              <DescriptionView spot={spot} />
            ) : (
              <NarrationView spot={spot} />
            )}
          </Box>
        </Flex>
      </ListItem>
    </Mergin>
  );
};

const NameView = ({ spot }: { spot: SpotForSidebar }) => {
  return (
    <Text ml={2} fontSize={"xl"}>
      {spot.name || "名称未設定"}
    </Text>
  );
};

const DescriptionView = ({ spot }: { spot: SpotForSidebar }) => {
  return (
    <Text ml={2} mt={4} fontSize={15} lineHeight={8}>
      {spot.description || ""}
    </Text>
  );
};

const NarrationView = ({ spot }: { spot: SpotForSidebar }) => {
  return (
    <Text ml={2} mt={4} fontSize={15} lineHeight={8}>
      {spot.narrationText || ""}
    </Text>
  );
};
